<button class="cursor-pointer bg-dangerous hover:bg-red-700 px-5 py-2 rounded text-center drop-shadow-lg w-full">
  <fa-icon *ngIf="_icon" [icon]="_icon" class="pr-1.5"></fa-icon>
  {{_text}}
</button>
